<template>
    <modal
      :name="computedModalTitle"
      :adaptive="true"
      height="auto"
      :width="500"
      transition="linear"
      id="deleteModal"
    >

      <modals-header
        :modalNameProp="computedModalTitle"
        @hideModalProp="hideDeleteModal"
      >
      </modals-header>
  
      <hr class="v--modal-hr">
      
      <div class="fp-modal">
        <div>{{ computedModalBody }}</div>
        <button
          type="button"
          class="generic-btn"
          @click="hideDeleteModal"
        >
          {{ computedModalNoBtn }}
        </button>
        <button
          type="button"
          class="action-btn btn-modal-delete"
          @click="deleteItem(guid)"
        >
          <span>{{ computedModalYesBtn }}</span>
        </button>
      </div>
    </modal>
</template>

<script>
  import modalsHeader from "@/components/common/modals/ModalsHeader";

  export default {
    name: "DeleteModal",
    components: {
      'modals-header': modalsHeader
    },
    data() {
      return {
        type: '',
        guid: '',
        typeOfDeletion: ''
      };
    },
    computed: {
      computedModalTitle() {
        const str = this.$lang.messages.deleteModalTitle.substr(0, this.$lang.messages.deleteModalTitle.indexOf('ITEM'));
        const str2 = this.$lang.messages.deleteModalTitle.substr(str.length + 4, this.$lang.messages.deleteModalTitle.length);
        return str.concat(this.type).concat(str2);
      },
      computedModalBody() {
        const str = this.$lang.messages.deleteModalBody.substr(0, this.$lang.messages.deleteModalBody.indexOf('ITEM'));
        const str2 = this.$lang.messages.deleteModalBody.substr(str.length + 4, this.$lang.messages.deleteModalBody.length);
        return str.concat(this.type).concat(str2);
      },
      computedModalYesBtn() {
        const str = this.$lang.messages.deleteModalYesBtn.substr(0, this.$lang.messages.deleteModalYesBtn.indexOf('ITEM'));
        const str2 = this.$lang.messages.deleteModalYesBtn.substr(str.length + 4, this.$lang.messages.deleteModalYesBtn.length);
        return str.concat(this.type).concat(str2);
      },
      computedModalNoBtn() {
        const str = this.$lang.messages.deleteModalNoBtn.substr(0, this.$lang.messages.deleteModalNoBtn.indexOf('ITEM'));
        const str2 = this.$lang.messages.deleteModalNoBtn.substr(str.length + 4, this.$lang.messages.deleteModalNoBtn.length);
        return str.concat(this.type).concat(str2);
      }
    },
    methods: {
      /**
       * Shows the modal with our data.
       * @param guid -- What we wanna delete.
       * @param type -- Type of deletion displayed to the user. IE: Yes, delete payment.
       * @param typeOfDeletion -- What even we will emit.
       */
      show(guid, type, typeOfDeletion) {
        this.type = type;
        this.guid = guid;
        this.typeOfDeletion = typeOfDeletion;
        setTimeout(() => this.$modal.show(this.computedModalTitle), 0)
      },
      hideDeleteModal() {
        this.$modal.hide(this.computedModalTitle)
      },
      deleteItem(guid) {
        switch(this.typeOfDeletion) {
          case 'deleteExpense':
            this.deleteExpense(guid);
            return;
          case 'deleteChild':
            this.deleteChild(guid);
            return;
          case 'deleteCoparent':
            this.deleteCoparent(guid);
            return;
          case 'deleteCard':
            this.deleteCard(guid);
            return;
          case 'deleteBankAccount':
            this.deleteBankAccount(guid);
            return;
          case 'deleteEvent':
            this.deleteEvent(guid);
            return;
          default: return
        }
      },
      deleteExpense(guid) {
        this.$emit("deleteExpense", guid);
        this.hideDeleteModal();
      },
      deleteChild(guid) {
        this.$emit("deleteChild", guid);
        this.hideDeleteModal();
      },
      deleteCoparent(guid) {
        this.$emit("deleteCoparent", guid);
        this.hideDeleteModal();
      },
      // Braintree subscription
      deleteCard(guid) {
        this.$emit("deleteCard", guid);
        this.hideDeleteModal();
      },
      // Checkbook accounts
      deleteBankAccount(guid) {
        this.$emit("deleteBankAccount", guid);
        this.hideDeleteModal();
      },
      // Single Event Calendar Dialog
      deleteEvent(guid) {
        this.$emit("deleteEvent", guid);
        this.hideDeleteModal();
      }
    }
  }
</script>
